import {
  ADD_PROJECT_URL,
  CHANGE_PASSWORD_URL,
  DELETE_PROJECT_URL,
  EDIT_PROJECT_URL,
  FILE_UPLOAD_URL,
  LIST_OF_ENQUIRY_URL,
  LIST_OF_PROJECTS_URL,
  LOGIN_URL,
  UPDATE_INQUIRY_URL,
  UPDATE_PASSWORD_URL,
  VERIFY_EMAIL_URL,
  VIEW_PROJECT_URL,
} from "API/Routes/Routes";
import { authData, multipartDataWithToken, nonAuthData } from "./services";

export const LOGIN_USER_COMMON = async (data: object) => {
  const response = await nonAuthData.post(LOGIN_URL, data);
  return response?.data;
};

export const REQUEST_VERIFY_EMAIL_COMMON = async (data: object) => {
  const response = await nonAuthData.post(VERIFY_EMAIL_URL, data);
  return response?.data;
};

export const REQUEST_UPDATE_PASSWORD_COMMON = async (data: object) => {
  const response = await nonAuthData.put(UPDATE_PASSWORD_URL, data);
  return response?.data;
};

export const REQUEST_CHANGE_PASSWORD_COMMON = async (data: object) => {
  const response = await authData.put(CHANGE_PASSWORD_URL, data);
  return response?.data;
};

export const REQUEST_ADD_PROJECT_COMMON = async (data: object) => {
  const response = await authData.post(ADD_PROJECT_URL, data);
  return response?.data;
};

export const REQUEST_FILE_UPLOAD_COMMON = async (data: object) => {
  const response = await multipartDataWithToken.post(FILE_UPLOAD_URL, data);
  return response?.data;
};

export const REQUEST_LIST_OF_PROJECTS_COMMON = async (data: object) => {
  const response = await authData.post(LIST_OF_PROJECTS_URL, data);
  return response?.data;
};

export const REQUEST_EDIT_PROJECT_COMMON = async (id:number,data: any) => {
  const response = await authData.put(`${EDIT_PROJECT_URL}${id}`, data);
  return response?.data;
};

export const REQUEST_DELETE_PROJECT_COMMON = async (id:number) => {
  const response = await authData.delete(`${DELETE_PROJECT_URL}${id}`);
  return response?.data;
};

export const REQUEST_VIEW_PROJECT_COMMON = async (id:number) => {
  const response = await authData.get(`${VIEW_PROJECT_URL}${id}`);
  return response?.data;
};


export const API_FETCH_ENQUIRIES = async (data: object) => {
  const response = await authData.post(LIST_OF_ENQUIRY_URL, data);
  return response?.data;
};


export const API_UPDATE_INQUIRY_STATUS= async (id: number, data :any) => {
  const response = await authData.put(`${UPDATE_INQUIRY_URL}${id}`, data);
  return response?.data;
};